import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, forwardRef } from 'react';
import { CancelIcon } from '@chegg-ui/theme';
import { MenuIcon } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { useHamburgerMenu, HeaderContext, onClickLogoRio } from '../../shared';
import { HamburgerMenuContainer, HamburgerMenuHead, ScreenBlocker } from '../../styles/mobile';
import CheggLogo from '../shared/cheggLogo';
var HamburgerMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var logo = _ref.logo,
      _onClickLogo = _ref.onClickLogo,
      onCloseHamburger = _ref.onCloseHamburger,
      onOpenHamburger = _ref.onOpenHamburger,
      children = _ref.children;

  var _useHamburgerMenu = useHamburgerMenu({
    onCloseHamburger: onCloseHamburger,
    onOpenHamburger: onOpenHamburger
  }),
      isOpen = _useHamburgerMenu.isOpen,
      openHamburgerMenu = _useHamburgerMenu.openHamburgerMenu,
      closeHamburgerMenu = _useHamburgerMenu.closeHamburgerMenu,
      launcher = _useHamburgerMenu.launcher,
      aborter = _useHamburgerMenu.aborter;

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HamburgerMenuContainer, {
    role: "navigation",
    "aria-label": "Main",
    isOpen: isOpen,
    "data-test": "".concat(dataTestPrefix, "-hamburger-menu-container"),
    onKeyDown: function onKeyDown(event) {
      event.stopPropagation(); // stopping the event propagation coz this event is only specific to hamburger menu

      if (event.key === 'Escape') // closing the popup on pressing "Escape" button
        closeHamburgerMenu(event);
    },
    ref: ref
  }, /*#__PURE__*/React.createElement(HamburgerMenuHead, {
    "data-test": "".concat(dataTestPrefix, "-hamburger-menu-head")
  }, /*#__PURE__*/React.createElement(CheggLogo, {
    logo: logo,
    onClickLogo:
    /* istanbul ignore next */
    function onClickLogo(e) {
      onClickLogoRio(true);
      _onClickLogo === null || _onClickLogo === void 0 ? void 0 : _onClickLogo(e);
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    "data-test": "".concat(dataTestPrefix, "-hamburger-menu-close"),
    onClick: function onClick(e) {
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            element: {
              name: 'close nav bar',
              type: 'icon',
              region_name: 'side nav'
            },
            type: 'click'
          }
        }
      }));
      closeHamburgerMenu(e);
    },
    screenReaderOnlyText: "Close navigation",
    ref: aborter,
    size: "small"
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), children), /*#__PURE__*/React.createElement(ScreenBlocker, {
    isActive: isOpen,
    onClick: closeHamburgerMenu,
    "data-test": "".concat(dataTestPrefix, "-hamburger-menu-screen-blocker")
  }), /*#__PURE__*/React.createElement(IconButton, {
    "aria-expanded": isOpen,
    "aria-haspopup": true,
    onFocus: closeHamburgerMenu,
    onClick: function onClick(e) {
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            element: {
              name: 'nav hamburger',
              type: 'icon',
              region_name: 'side nav'
            },
            type: 'expand'
          }
        }
      }));
      openHamburgerMenu(e);
    },
    screenReaderOnlyText: "Navigation",
    ref: launcher,
    "data-test": "".concat(dataTestPrefix, "-hamburger-menu-open"),
    size: "small"
  }, /*#__PURE__*/React.createElement(MenuIcon, null)));
});
HamburgerMenu.displayName = 'HamburgerMenu';
export default HamburgerMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/signed-out-header/dist/esm/components/mobile/mobileHamburgerMenu.js
// module id = 5639
// module chunks = 11